/**
 * Created by idea on 03/07/2017.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { AdminNavComponent } from "./admin-nav.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [AdminNavComponent],
  imports: [CommonModule, RouterModule, TranslateModule.forChild()],
  exports: [AdminNavComponent],
})
export class NavigationModule { }



// WEBPACK FOOTER //
// /app/src/app/layout/navigation/navigation.module.ts